import { get, isNil } from 'lodash';

function sortBy(fieldName = '') {
    return (a, b) => {
        const aVal = get(a, fieldName);
        const bVal = get(b, fieldName);
    
        if (isNil(aVal)) {
            return isNil(bVal) ? 0 : 1;
        }
    
        if (isNil(bVal)) {
            return -1;
        }
    
        if (typeof aVal === 'string') {
            const lowercase = {
                a: aVal.toLowerCase(),
                b: bVal.toLowerCase()
            };
    
            if ( lowercase.a < lowercase.b )
                return -1;

            if ( lowercase.a > lowercase.b )
                return 1;
            
            return 0;
        }
    
        if (typeof aVal === 'number') {
            return aVal - bVal;
        }
    };
}

export default sortBy;